import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgForbidden = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.475 14.8906L5.10938 6.525C4.40937 7.50313 4 8.70312 4 10C4 13.3125 6.6875 16 10 16C11.2969 16 12.4969 15.5906 13.475 14.8906ZM14.8906 13.475C15.5906 12.4969 16 11.2969 16 10C16 6.6875 13.3125 4 10 4C8.70312 4 7.50313 4.40937 6.525 5.10938L14.8906 13.475ZM2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10Z",
		fill: "#0D2976"
	})
});
export default SvgForbidden;
